<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Careers"
                        sub-title="Viewing career drafts"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button v-if="career" element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'careers.home' })">
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading">
                <app-table v-if="career && career.drafts.length > 0 && checkPermission('careers', 'publishable')">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(d, i) in career.drafts" :key="i">
                            <app-table-cell>
                                {{ d.title }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <span v-if="d.locale.flag != locale.flag">
                                        <img :src="require(`../../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </span>
                                    <span v-else>
                                        <img :src="require(`../../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </span>
                                </div>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'careers.view', params: { id: d.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('careers', 'edit')">
                                    <app-icon icon="eye" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = d.id" v-if="checkPermission('careers', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a career draft. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';

    /* Mixins */
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'careers.drafts.home',

        data: () => ({
            loading: false,
            career: null,
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal
        },

        mixins: [ Permissions ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getCareer(this.$route.params.id)
                    .then(response => {
                        this.loading = false;
                    })
                    .catch(error => {
                        this.$router.push({name: 'careers.home'});
                    });
            } else {
                this.$router.push({name: 'careers.home'});
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },

        methods: {
            getCareer(id) {
                return Api.request('get', `careers/edit/${id}`)
                    .then(({ data }) => {
                        this.career = data.career;
                        this.response = data;
                    });
            },
            isTranslated(career, locale) {
                let translated = false;

                if (career.children.length > 0 && career.locale.flag != locale.flag) {
                    career.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            translated = true;
                        }
                    });
                }
                
                return translated;
            },
            getId(career, locale) {
                let id = career.id;

                if (career.children.length > 0 && career.locale.flag != locale.flag) {
                    career.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            id = child.id;
                        }
                    });
                }

                return id;
            },
            deleteCareers(id) {
                return Api.request('get', `careers/delete/${id}`);
            },
            remove() {
                this.confirmModalOpened = false;
                this.loading = true;

                this.deleteCareers( this.confirmModalId ).then(response => {
                    return this.getCareer(this.$route.params.id);
                }).then(response => {
                    this.loading = false;
                    this.confirmModalId = false;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/careers/drafts/Home.vue